import { z } from 'zod';

const DATE = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

export type EditorKind = 'invoice' | 'order';

const contact = z
  .object({ id: z.string(), name: z.string() })
  .loose()
  .nullable()
  .refine((c) => c !== null, 'Choose a customer');

/** Header fields of the invoice / order editor. `later` is the due date (invoice) or expected date (order). */
export const documentHeaderSchema = z
  .object({
    contact,
    docDate: z.string().regex(DATE, 'Enter a date'),
    later: z.string().refine((v) => v === '' || DATE.test(v), 'Enter a date'),
    locationId: z.string(),
    reference: z.string().trim().max(100, 'At most 100 characters'),
    notes: z.string().trim().max(2000, 'At most 2000 characters'),
  })
  .refine((v) => v.later === '' || v.later >= v.docDate, {
    path: ['later'],
    message: 'Must be on or after the document date',
  });

export type DocumentHeader = z.input<typeof documentHeaderSchema>;

/** API error paths → editor fields. */
export function headerField(path: string): keyof DocumentHeader | null {
  const map: Record<string, keyof DocumentHeader> = {
    contactId: 'contact',
    docDate: 'docDate',
    dueDate: 'later',
    expectedDate: 'later',
    locationId: 'locationId',
    reference: 'reference',
    notes: 'notes',
  };
  return map[path] ?? null;
}
